const Robodog = require('@uppy/robodog');
import {ParameterValidator} from '@mvps-genesis/utilities';
import {extractElement} from 'extensions/extract-element';
require('@uppy/robodog/dist/robodog.css');

export default class RobodogPicker {

	constructor () {
		this.validator = new ParameterValidator(this);

		this.savedResponseElem = this.validator.isElement('savedResponseElem', '#l-WarrantyInvoice');
		this.uploadButtonElem = this.validator.isElement('uploadButtonElem', '#js-warranty-checkout-invoice-upload');
		this.uploadContentContainerElem = this.validator.isElement('uploadContentContainerElem', '#js-uploaded-filename-container');
		this.uploadFilenamesElem = this.validator.isElement('uploadFilenamesElem', '#js-uploaded-filenames');
		this.uploadAgainBtnElem = this.validator.isElement('uploadAgainBtnElem', '#js-warranty-upload-again');

		// These grab the data we need from the elements holding our policy and signature for Transloadit
		this.params 	= extractElement('#tli_policy');
		this.signature	= extractElement('#tli_sig');
		this.templateID = extractElement('#tli_templateid');

		this.bindEvents();
	}

	bindEvents () {
		this.uploadAgainBtnElem.addEventListener('click', () => this.openPicker());
	}

	openPicker () {
		const self = this;
		const resultPromise = Robodog.pick({
			closeModalOnClickOutside: true,
			params: self.params,
			providers: [
				'webcam',
				'url',
				'dropbox'
			],
			signature: self.signature,
			template_id: self.templateID,
			waitForEncoding: true
		});

		resultPromise.then((bundle) => {
			let savedResponse = [];
			let filenames = [];

			bundle.results.forEach(function (result) {
				if (result.stepName === 'viruscheck') {
					savedResponse.push({
						meta: result.meta,
						original_name: result.original_name,
						ssl_url: result.ssl_url
					});
					filenames.push(result.original_name);
				}
			});

			if (savedResponse.length > 0) {
				self.savedResponseElem.value = JSON.stringify(savedResponse);
				self.uploadButtonElem.classList.add('u-hidden');
				self.uploadFilenamesElem.innerHTML = filenames.join(', ');
				self.uploadContentContainerElem.classList.remove('u-hidden');
			}
		});
	}
}
